export const FORM_BARCODE = ({ onEnter }) => {
  return [
    {
      name: 'barcode',
      label: 'รหัสบาร์โค้ด',
      placeholder: '0 9 5 8 1 2 3 4 8',
      type: 'INPUT_BARCODE_AUTO',
      rules: {
        required: true,
        pattern: /^[0-9]{16}$/,
      },
      maxLength: 16,
      onEnter,
      style: { textAlign: 'center' },
      inputStyle: { textAlign: 'center' },
    },
  ];
};
